export const { ACTIVE, INACTIVE } =
  {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive'
  };
